module.exports = __webpack_public_path__ + "static/media/ibBTC.7ce9c27e.svg";